import * as React from 'react';
import { KeywordCalculation } from '../logic/useCalculateKeywords';
import { animated, useSpring } from 'react-spring';
import {
  Box,
  createStyles,
  lighten,
  makeStyles,
  Theme,
  Typography,
  useTheme,
} from '@material-ui/core';
import { formatNumber } from '../../../../../../../../../logic/otherUtilities/formatting/formatNumber';
import moment from 'moment';
import VoxelText from '../../../../../../../../voxel/Text/VoxelText';
import VoxelAlert from '../../../../../../../../voxel/Alert/VoxelAlert';

export interface ComboWordCounterProps {
  wordCount: KeywordCalculation;
  executed: boolean;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    timeEstimate: {
      fontSize: '21px',
    },
  })
);

const ComboWordCounter: React.FC<ComboWordCounterProps> = ({ wordCount, executed }) => {
  const springNumbers = useSpring({
    keywordCount: wordCount.keywordCount,
  });

  const classes = useClasses();
  const theme = useTheme();

  return (
    <div className="flex flex-col gap-4">
      <div className="p-4 bg-gray-100 rounded flex flex-col gap-2">
        <VoxelText>Resulting number of keywords</VoxelText>
        <VoxelText variant="bread-semibold">
          <animated.span>
            {springNumbers.keywordCount.to((val) => formatNumber(val, 0, '-'))}
          </animated.span>
        </VoxelText>
      </div>
      <div className="p-4 bg-gray-100 rounded flex flex-col gap-2">
        <VoxelText>Estimated time to execute (minimum)</VoxelText>

        <VoxelText variant="bread-semibold">
          {wordCount.timeToExecuteMs > 0
            ? moment.duration(wordCount.timeToExecuteMs).humanize()
            : '-'}
        </VoxelText>
      </div>
      {!executed && wordCount.requestPermission && (
        <VoxelAlert severity="warning" skipIcon>
          You need to coordinate with the Voxel team before executing this request
        </VoxelAlert>
      )}
    </div>
  );
};

export default ComboWordCounter;
